import "../../pages/Home/styles.css";
import StudioBXRecipe from "../../components/StudioBXRecipe/studioBXRecipe.jsx";
function Home() {
  return (
      <section className="homeWrapper">
         <StudioBXRecipe />
      </section>
  );
}

export default Home;
